import { combineReducers } from 'redux'

import { PCRChannels } from '@enums'
import { snapMetricsReducer } from '@store/postCampaignReport/snapMetrics/reducer'
import { xMetricsReducer } from '@store/postCampaignReport/xMetrics/reducer'
import { generatePCRMetricsReducer } from './metrics/reducer'
import { campaignMetricsReducer } from './campaignMetrics'
import { postMetricsReducer } from './postsMetrics'
import { reelMetricsReducer } from './reelMetrics'
import { storyMetricsReducer } from './storyMetrics'
import { tiktokMetricsReducer } from './tiktokMetrics'
import { IPostCampaignReportState } from './types'

export const postCampaignReducer = combineReducers<IPostCampaignReportState>({
  campaignMetrics: campaignMetricsReducer,
  postMetrics: postMetricsReducer,
  storyMetrics: storyMetricsReducer,
  tiktokMetrics: tiktokMetricsReducer,
  reelMetrics: reelMetricsReducer,
  xMetrics: xMetricsReducer,
  snapMetrics: snapMetricsReducer,
  [PCRChannels.YouTubeShorts]: generatePCRMetricsReducer(PCRChannels.YouTubeShorts),
  [PCRChannels.YouTubeVideos]: generatePCRMetricsReducer(PCRChannels.YouTubeVideos),
})
